var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHightStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 33"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5",
    cx: 6.23828,
    cy: 6,
    r: 6,
    fill: "#E62E2E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHightStatus);
export default __webpack_public_path__ + "static/media/hight_status.622832c82af1dd845727c2893cc5c870.svg";
export { ForwardRef as ReactComponent };